// extracted by mini-css-extract-plugin
export default {"modal_body_splash":"TermsAgreementModal_modal_body_splash__qxtpo","modal_body_text":"TermsAgreementModal_modal_body_text__h8X9Z"};